export const IS_DEBUG = false

//name
export const NUser = 'user'
export const NInfo = 'NInfo'
export const NComment = 'NComment'
export const NPersonal = 'NPersonal'
export const NHomePage = 'NHomePage'

//effects
export const EPostRegister = 'postRegister'
export const EPostLogin = 'postLogin'
export const EGuestLogin = 'guestLogin'
export const EGetInfo = 'EGetInfo'
export const EGetInfoDetail = 'EGetInfoDetail'
export const EPostInfo = 'EPostInfo'
export const EGetTopic = 'EGetTopic'
export const EGetCategory = 'EGetCategory'
export const EGetComment = 'EGetComment'
export const EPostComment = 'EPostComment'
export const EPostCommentReply = 'EPostCommentReply'
export const EPostVisitInfo = 'EPostVisitInfo'
export const EPostCollectInfo = 'EPostCollectInfo'
export const EPostLikeInfo = 'EPostLikeInfo'
export const EGetUser = 'EGetUser'
export const EPostUser = 'EPostUser'
export const EPutPassword = 'EPutPassword'
export const EPostMyInfo = 'EPostMyInfo'
export const EDelMyInfo = 'EDelMyInfo'
export const EGetUserCollect = 'EGetUserCollect'
export const EGetSearch = 'EGetSearch'
export const EGetHotSearch = 'EGetHotSearch'
export const EGetVisitInfo = 'EGetVisitInfo'
export const EGetMessage = 'EGetMessage'
export const EUpdateMessage = 'EUpdateMessage'
export const EGetCode = 'EGetCode'
export const EGetWechatCode = 'EGetWechatCode'
export const EGetLoginStatus = 'EGetLoginStatus'
export const EBindWechat = 'EBindWechat'
export const EGetHomePageTopList = 'EGetHomePageTopList'
export const EGetHomePageOtherList = 'EGetHomePageOtherList'
export const EGetHomePageVoiceList = 'EGetHomePageVoiceList'
export const EGetHomePageTopTen = 'EGetHomePageTopTen'
export const EGetHotVideo = 'EGetHotVideo'
export const EPutUserPassword = 'EPutUserPassword'

export const EBindWechatStatus = 'EBindWechatStatus'
/*------------------------------ 微信相关 ------------------------------*/
export const EWechatQRCode = 'EWechatQRCode'
export const ETokenByWechat = 'ETokenByWechat'
export const EBindUserByWechat = 'EBindUserByWechat'

//reduce
export const RLogin = 'login'
export const RSetState = 'RSetState'
export const RTopic = 'Topic'
export const RCategory = 'RCategory'
export const RSetInfoList = 'RSetInfoList'
export const RInfoDetail = 'InfoDetail'
export const RSetInfoItem = 'RSetInfoItem'
export const RSetVoiceList = 'RSetVoiceList'

// Bread
export const AspirationsBread = [{ title: '内部心声', url: '/aspirations' }]
export const EmperorBread = [{ title: '帝业人', url: '/emperor' }]
export const ArticleDetailBread = [{ title: '内部心声', url: '/aspirations' }]
export const RegistBread = [{ title: '注册', url: '/regist' }]
export const LoginBread = [{ title: '登录', url: '/login' }]

// 富文本编辑器控件
// https://www.yuque.com/braft-editor/be/gz44tn#0hgysg
export const EditControl = [
  'undo',
  'redo',
  'separator',
  'font-size',
  'line-height',
  'letter-spacing',
  'separator',
  'text-color',
  'bold',
  'italic',
  'underline',
  'strike-through',
  'separator',
  'emoji',
  'separator',
  'text-indent',
  'text-align',
  'separator',
  'headings',
  'list-ul',
  'list-ol',
  'blockquote',
  'code',
  'separator',
  'link',
  'separator',
  'hr',
  'separator',
  'separator',
  'clear',
]

// setting-title
export const settingTitle = {
  1: '我的主页',
  2: '我的资料',
  3: '密码安全',
  4: '微信绑定',
  5: '我的帖子',
  6: '收藏的帖子',
  7: '系统通知',
}
